module.exports = __webpack_public_path__ + "static/information-inline-example-f77cd043be6625469c4774e10b09c76c.svg";